<template>
  <div class="courtier_area" style="text-align: center">
    <div style="width: 400px; margin: auto" class="ui fluid large icon input">
      <a-input
        v-model:value="searchInput"
        placeholder="Nom de courtier ..."
      ></a-input>
    </div>

    <a-divider></a-divider>

    <a-card title="Courtiers">
      <a-card-grid
        v-for="c in courtiers"
        :key="c.uuid"
        @click="selectBroker(c.internal_number)"
        style="width: 25%; text-align: center; cursor: pointer"
      >
        <div
          :style="
            c.internal_number == broker.internal_number
              ? { backgroundColor: 'darkred', color: 'white' }
              : {}
          "
          style="font-size: 16px; font-weight: bold"
        >
          {{ c.name }}
        </div>
        <div style="color: darkgrey">{{ c.internal_number }}</div>
      </a-card-grid>
    </a-card>
  </div>
</template>

<script>
export default {
  name: "brokers",
  components: {},
  data: function () {
    return {
      searchInput: "",
    };
  },
  methods: {
    selectBroker(broker_internal_number) {
      this.axios.post("/data/select", { broker_internal_number }).then((r) => {
        if (r.status === 200) {
          window.location.replace("/");
        }
      });
    },
  },
  computed: {
    broker() {
      return this.$store.getters.broker;
    },
    grBrokers() {
      return this.$store.getters.grBrokers;
    },
    courtiers() {
      const brokers = this.grBrokers.filter((c) => {
        if (c.name.toUpperCase().indexOf(this.searchInput.toUpperCase()) !== -1)
          return c;
      });

      brokers.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      return brokers;
    },
  },
};
</script>
<style media="screen">
.courtier_area {
  padding: 100px 20px 0 80px;
}
</style>
